// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Offer24CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Offer24CircleFilled: FC<Offer24CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path d="M21.558 12.063a1.449 1.449 0 0 1-1.064.437 1.45 1.45 0 0 1-1.064-.438A1.446 1.446 0 0 1 18.992 11c0-.417.146-.77.438-1.063a1.45 1.45 0 0 1 1.064-.437c.418 0 .772.146 1.064.438.292.291.438.645.438 1.062 0 .417-.146.77-.438 1.063Z" />
            <path
                d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm-2.59-5.65c.25.1.501.15.751.15s.501-.05.751-.15a2 2 0 0 0 .676-.45l8.836-8.825a1.971 1.971 0 0 0 .576-1.4V8.5c0-.55-.196-1.02-.588-1.413a1.93 1.93 0 0 0-1.415-.587h-7.184a2.076 2.076 0 0 0-1.427.6l-8.81 8.825c-.2.2-.347.425-.438.675a2.06 2.06 0 0 0 0 1.487c.091.242.237.463.438.663l7.159 7.15a2 2 0 0 0 .676.45Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Offer24CircleFilled;
